// src/data/itemsData.js
const allItems = [
  { id: 1, name: 'T-Shirt', price: '₹499', rating: 4.5, image: '/assets/Features/f1.jpg' },
  { id: 2, name: 'Jeans', price: '₹999', rating: 4.0, image: '/assets/Features/f2.jpg' },
  { id: 3, name: 'Jacket', price: '₹1299', rating: 5.0, image: '/assets/Features/f3.jpg' },
  { id: 4, name: 'Sneakers', price: '₹1499', rating: 4.2, image: '/assets/Features/f4.jpg' },
  { id: 5, name: 'Cap', price: '₹299', rating: 3.8, image: '/assets/Features/f5.jpg' },
  { id: 6, name: 'Dress', price: '₹899', rating: 4.7, image: '/assets/Features/f6.jpg' },
  { id: 7, name: 'Kurti', price: '₹799', rating: 4.1, image: '/assets/Features/f7.jpg' },
  { id: 8, name: 'Scarf', price: '₹249', rating: 4.4, image: '/assets/Features/f8.jpg' },
  { id: 9, name: 'Sweatpants', price: '₹699', rating: 4.2, image: '/assets/Features/f9.jpg' },
  { id: 10, name: 'Leggings', price: '₹499', rating: 4.3, image: '/assets/Features/f10.jpg' },
  { id: 11, name: 'Formal Shirt', price: '₹799', rating: 4.1, image: '/assets/Features/f11.jpg' },
  { id: 12, name: 'Palazzo Pants', price: '₹599', rating: 4.3, image: '/assets/Features/f12.jpg' },
  { id: 13, name: 'Leather Jacket', price: '₹1999', rating: 4.7, image: '/assets/Features/f13.jpg' },
  { id: 14, name: 'Denim Skirt', price: '₹649', rating: 4.2, image: '/assets/Features/f14.jpg' },
  { id: 15, name: 'Chinos', price: '₹899', rating: 4.0, image: '/assets/Features/f15.jpg' },
  { id: 16, name: 'Graphic Tee', price: '₹349', rating: 4.5, image: '/assets/Features/f16.jpg' },
  { id: 17, name: 'Puffer Jacket', price: '₹1599', rating: 4.6, image: '/assets/Features/f17.jpg' },
  { id: 18, name: 'Crop Top', price: '₹399', rating: 4.3, image: '/assets/Features/f18.jpg' },
  { id: 19, name: 'Cargo Pants', price: '₹999', rating: 4.4, image: '/assets/Features/f19.jpg' },
  { id: 20, name: 'Party Dress', price: '₹1299', rating: 4.5, image: '/assets/Features/f20.jpg' },
  { id: 21, name: 'Anarkali Kurti', price: '₹899', rating: 4.3, image: '/assets/Features/f21.jpg' },
  { id: 22, name: 'Canvas Shoes', price: '₹799', rating: 4.1, image: '/assets/Features/f22.jpg' },
  { id: 23, name: 'Tank Top', price: '₹299', rating: 4.0, image: '/assets/Features/f23.jpg' },
  { id: 24, name: 'Blazer', price: '₹1799', rating: 4.6, image: '/assets/Features/f24.jpg' },
];

export default allItems;
